import Swal from "sweetalert2";
import axios from "axios";

export const confirmAndDelete = async ({ id, url }) => {
  return Swal.fire({
    title: "Are you sure?",
    text: "This action cannot be undone.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#CD1B1B",
    cancelButtonColor: "#6B7280",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
    reverseButtons: false,
    background: "#fff",
    customClass: {
      popup: "rounded-2xl shadow-lg",
      title: "font-heading text-lg text-primaryTextColor ",
      confirmButton: "rounded-lg px-4 py-2 bg-primaryBtnColor",
      cancelButton: "rounded-lg px-4 py-2",
    },
    showLoaderOnConfirm: true,
    allowOutsideClick: () => !Swal.isLoading(),
    preConfirm: async () => {
      try {
        // await new Promise((resolve) => setTimeout(resolve, 6000));
        await axios.delete(`${url}/${id}`);

        return true;
      } catch (err) {
        Swal.showValidationMessage("Failed to delete. Try again.");
        return false;
      }
    },
  }).then((result) => {
    return result.isConfirmed;
  });
};

// import Swal from "sweetalert2";
// import axios from "axios";

// export const confirmAndDelete = async ({ id, url, onSuccess, onError }) => {
//   return Swal.fire({
//     title: "Are you sure?",
//     text: "This action cannot be undone.",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonColor: "#FF4141",
//     cancelButtonColor: "#6B7280",
//     confirmButtonText: "Yes, delete it!",
//     cancelButtonText: "Cancel",
//     reverseButtons: true,
//     showLoaderOnConfirm: true,
//     allowOutsideClick: () => !Swal.isLoading(),
//     preConfirm: async () => {
//       try {
//         await new Promise((resolve) => setTimeout(resolve, 2000));

//         await axios.delete(`${url}/${id}`);
//       } catch (err) {
//         Swal.showValidationMessage("Failed to delete. Try again.");
//         throw err;
//       }
//     },
//   }).then((result) => {
//     if (result.isConfirmed) {
//       Swal.fire({
//         icon: "success",
//         title: "Deleted!",
//         text: "Item has been removed successfully.",
//         confirmButtonColor: "#10B981",
//       });
//       if (onSuccess) onSuccess();
//     } else if (result.dismiss) {
//       if (onError) onError();
//     }
//   });
// };
